package com.kinoshazam.uiKit.components.image

import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale

data class ImageUiKitState(
    val url: String?,
    val tintColor: ColorFilter? = null,
    val placeholder: Painter? = null,
    val placeholderColor: Color? = null,
    val contentDescription: String? = null,
    val size: Size? = null,
    val contentScale: ContentScale = ContentScale.Fit,
)
